import { Route } from 'react-router';
import MainControlScreen from 'src/components/screens/MainControlScreen';
import ProfileScreen from 'src/components/screens/ProfileScreen';
import DashboardScreen from '../components/screens/DashboardScreen';
import EnvVarScreen from '../components/screens/EnvVars';
import LoginScreen from '../components/screens/Login';
import ExternalLoginScreen from '../components/screens/Login/ExternalLogin/ExternalLoginScreen';
import QuotationDetailsScreen from '../components/screens/Quotations/Details';
import DynamicQuotationPage from '../components/screens/Quotations/Dynamic';
import { QuotationHistoryPage } from '../components/screens/Quotations/History';
import { VinModicationPage } from '../components/screens/Quotations/VinModification';
import FallBackRoute from './FallBackRoute';
import PrivateRoute from './PrivateRoute';
import PublicOnlyRoute from './PublicOnlyRoute';
import LandingScreen from '../components/screens/Landing';

export default [
  <Route
    path="/profile"
    key="profile"
    element={
      <MainControlScreen
        component={
          <PrivateRoute>
            <ProfileScreen />
          </PrivateRoute>
        }
      />
    }
  />,
  <Route
    path="/"
    key="dashboard"
    element={
      <MainControlScreen
        component={
          <PrivateRoute>
            <DashboardScreen />
          </PrivateRoute>
        }
      />
    }
  />,
  <Route
    path="/quotationHistory/:id"
    key="quotationHistory"
    element={
      <MainControlScreen
        component={
          <PrivateRoute>
            <QuotationHistoryPage />
          </PrivateRoute>
        }
      />
    }
  />,
  <Route
    path="/dynamicQuotation"
    key="dynamicQuotation"
    element={
      <MainControlScreen
        component={
          <PrivateRoute>
            <DynamicQuotationPage />
          </PrivateRoute>
        }
      />
    }
  />,
  <Route
    path="/quotationDetails"
    key="quotationDetails"
    element={
      <MainControlScreen
        component={
          <PrivateRoute>
            <QuotationDetailsScreen />
          </PrivateRoute>
        }
      />
    }
  />,
  <Route
    path="/landing"
    key="landing"
    element={
      <MainControlScreen
        component={
          <PrivateRoute>
            <LandingScreen />
          </PrivateRoute>
        }
      />
    }
  />,
  <Route
    path="/:authType/login"
    key="login"
    element={
      <MainControlScreen
        component={
          <PublicOnlyRoute>
            <LoginScreen />
          </PublicOnlyRoute>
        }
      />
    }
  />,
  <Route
    path="/externalLogin"
    key="externalLogin"
    element={
      <MainControlScreen
        component={
          <PublicOnlyRoute>
            <ExternalLoginScreen />
          </PublicOnlyRoute>
        }
      />
    }
  />,
  <Route
    path="/vinModification/:id"
    key="vinModification"
    element={
      <MainControlScreen
        component={
          <PrivateRoute>
            <VinModicationPage />
          </PrivateRoute>
        }
      />
    }
  />,
  <Route
    key="enviroment"
    path="/enviroment"
    element={<MainControlScreen component={<EnvVarScreen />} />}
  />,
  <Route
    path="*"
    key="all"
    element={<MainControlScreen component={<FallBackRoute />} />}
  />,
];
